import { getListTransform, getDetailTransform } from 'helpers/transformResponse';
import types from './types';

const INITIAL_STATE = {
  list: {
    content: [],
  },
  detail: {},
  loading: false,
  surveySent: false,
};

/**
 * @param {Object} state - Default application state
 * @param {Object} action - Action from action creator
 * @returns {Object} New state
 */
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.SURVEYS_FETCHED:
      return {
        ...state,
        list: getListTransform(action.payload.data) || INITIAL_STATE.list,
        loading: false,
      };
    case types.SURVEY_DETAIL:
      return {
        ...state,
        detail: getDetailTransform(action.payload) || INITIAL_STATE.detail,
        loading: false,
      };
    case types.SURVEY_LOAD:
      return {
        ...state,
        loading: action.payload,
      };
    case types.SURVEY_SENT:
      return {
        ...state,
        surveySent: action.payload,
      };
    default:
      return state;
  }
};
